module.exports = __webpack_public_path__ + "img/christmascoupon_zh.3d3f8ff0.png";